import {
  getTravelCheckoutFormValues,
  getTravelCheckoutInsurantData,
  setMessageVisibility,
  setSectionMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { FormsEnum, MessagesEnum } from 'app/shared/enums';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';

const formName = FormsEnum.TravelCheckoutForm;

const insurantObfuscation = {
  showTravelInsurantPhoneNumberObfuscatedMessage(initialRun?: boolean) {
    const { phoneNumber } = getTravelCheckoutFormValues();

    const showObfuscatedMessage = checkIsDataObfuscated(
      phoneNumber,
      initialRun
    );

    setMessageVisibility({
      key: MessagesEnum.InsurancePhoneNumberObfuscated,
      visible: showObfuscatedMessage,
      formName,
    });
  },
  showTravelInsurantEmailObfuscatedMessage(initialRun?: boolean) {
    const { emailAddress } = getTravelCheckoutFormValues();

    const showObfuscatedMessage = checkIsDataObfuscated(
      emailAddress,
      initialRun
    );

    setMessageVisibility({
      key: MessagesEnum.CalculationInsurantEmailObfuscated,
      visible: showObfuscatedMessage,
      formName,
    });
  },

  showTravelInsurantDataObfuscatedMessage() {
    const { name, surname, pesel } = getTravelCheckoutInsurantData();

    const showObfuscatedMessage = [name, surname, pesel].some((item) =>
      checkIsDataObfuscated(item, true)
    );

    setSectionMessageVisibility({
      key: MessagesEnum.TravelInsurantDataObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.TravelCheckoutForm,
    });
  },
  showTravelInsurantHomeAddressObfuscatedMessage(initialRun?: boolean) {
    const { homeAddress } = getTravelCheckoutInsurantData();

    const showObfuscatedMessage = [
      homeAddress?.zipCode,
      homeAddress?.city,
      homeAddress?.streetName,
    ].some((item) => checkIsDataObfuscated(item, initialRun));

    setSectionMessageVisibility({
      key: MessagesEnum.TravelInsurantHomeAddressObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.TravelCheckoutForm,
    });
  },
};

export default insurantObfuscation;
